function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useMemo } from 'react';
import { Box, Typography } from '@applyboard/ui-components';
import { ALLOWS_FOR_ALL_COUNTRIES, EXCEPTION_EXISTS, TOEFL_NOT_REQUIRED_BAND_SCORE, IELTS_NOT_REQUIRED_BAND_SCORE, PTE_NOT_REQUIRED_BAND_SCORE, GMAT_NOT_REQUIRED_BAND_SCORE } from "./constants";
import { convertToFloat, extractMarks, elpRequired } from "./utils";
import { CollapsibleCard } from "../Card";
import EnglishRequirementException from "../ab-common-legacy/EnglishRequirementsExceptions";
var EnglishRequirementExceptions = function EnglishRequirementExceptions(_ref) {
  var englishRequirementExceptions = _ref.englishRequirementExceptions;
  var items = useMemo(function () {
    return englishRequirementExceptions ? englishRequirementExceptions.reduce(function (result, item) {
      var _item$countries;
      // The frequency of the nationality-specific scores isn't nearly as high
      // and we don't record "In/Not in". It's only "In".
      var marks = extractMarks(item);
      if (!((_item$countries = item.countries) !== null && _item$countries !== void 0 && _item$countries.length)) {
        return result;
      }
      var countries = item.countries[0];
      countries.forEach(function (country) {
        result.push(_objectSpread({
          countryName: country
        }, marks));
      });
      return result;
    }, []) : [];
  }, [englishRequirementExceptions]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, items === null || items === void 0 ? void 0 : items.map(function (item) {
    return /*#__PURE__*/React.createElement(EnglishRequirementException, {
      key: item.countryName,
      item: item
    });
  }));
};
export var ProgramEnglishRequirements = function ProgramEnglishRequirements(_ref2) {
  var englishRequirementExceptions = _ref2.englishRequirementExceptions;
  if (!(englishRequirementExceptions !== null && englishRequirementExceptions !== void 0 && englishRequirementExceptions.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CollapsibleCard, {
    fullWidth: true,
    initialOpenState: true,
    header: /*#__PURE__*/React.createElement(Typography, null, "This program has nationality specific English requirements"),
    nameForEventTracking: "English Requirements"
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "program-ere-info"
  }, /*#__PURE__*/React.createElement(EnglishRequirementExceptions, {
    englishRequirementExceptions: englishRequirementExceptions
  })));
};
export var DelayedProofOfELPInfo = function DelayedProofOfELPInfo(_ref3) {
  var value = _ref3.value;
  var content = useMemo(function () {
    switch (value) {
      case ALLOWS_FOR_ALL_COUNTRIES:
        {
          // program accepts for all countries
          return /*#__PURE__*/React.createElement(Typography, {
            "data-testid": "allows-for-all-countries",
            variant: "legal"
          }, "Applicants interested in applying for direct admission, but are yet to complete an acceptable language test, can do so, but must provide valid results before receiving a final offer letter.");
        }
      case EXCEPTION_EXISTS:
        {
          // program accepts/rejects when exception exists
          return /*#__PURE__*/React.createElement(Typography, {
            "data-testid": "exception-exists",
            variant: "legal"
          }, "Applicants interested in applying for direct admission, but are yet to complete an acceptable language test, can do so, but must provide valid results before receiving a final offer letter. (Varies based on student nationality)");
        }
      default:
        {
          // program doesn't accept for all countries
          return null;
        }
    }
  }, [value]);
  return content && /*#__PURE__*/React.createElement(CollapsibleCard, {
    fullWidth: true,
    initialOpenState: true,
    header: /*#__PURE__*/React.createElement(Typography, null, "This program requires valid language test results"),
    nameForEventTracking: "Proof of ELP Info"
  }, content);
};
export var EnglishScoreRequired = function EnglishScoreRequired(_ref4) {
  var englishScoreRequired = _ref4.englishScoreRequired,
    schoolName = _ref4.schoolName,
    marks = _ref4.marks,
    englishRequirementExceptions = _ref4.englishRequirementExceptions;
  var isElpRequired = elpRequired(marks);
  var formatScores = function formatScores(englishTestName) {
    var showUnlessLte = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var keysToDisplay = {};
    if (englishTestName === 'ielts') {
      keysToDisplay = {
        minIeltsListening: 'Min Listening',
        minIeltsReading: 'Min Reading',
        minIeltsSpeaking: 'Min Speaking',
        minIeltsWriting: 'Min Writing'
      };
    } else if (englishTestName === 'toefl') {
      keysToDisplay = {
        minToeflListening: 'Min Listening',
        minToeflReading: 'Min Reading',
        minToeflSpeaking: 'Min Speaking',
        minToeflWriting: 'Min Writing'
      };
    } else if (englishTestName === 'pte') {
      keysToDisplay = {
        minPteListening: 'Min Listening',
        minPteReading: 'Min Reading',
        minPteSpeaking: 'Min Speaking',
        minPteWriting: 'Min Writing'
      };
    }
    return Object.keys(keysToDisplay).filter(function (key) {
      return marks[key] > showUnlessLte;
    }).map(function (key) {
      return "".concat(keysToDisplay[key], ": ").concat(marks[key]);
    }).join(', ') || '';
  };
  var content = useMemo(function () {
    if (englishScoreRequired) {
      // This program does NOT offer conditional admission.
      return null;
    }
    if (schoolName === 'Centennial College') {
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "legal",
        "data-testid": "conditional-admission-centennial-college"
      }, "For conditional admission, if you do NOT meet the minimum English requirement (IELTS, TOEFL or Duolingo), you may still be eligible for a conditional offer letter for some programs with the condition of completing the Centennial College English Assessment test upon arrival. If you do not meet the minimum score, English Language Learning or Foundations programs at Centennial College can prepare and qualify you for your program choice.");
    }
    if (!isElpRequired) {
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "legal",
        "data-testid": "conditional-admission-does-not-require-elp"
      }, "For conditional admission, instead of submitting language proficiency test scores, applicants may complete English courses prior to the academic program. The length of the English course is determined based on the applicant\u2018s level of English proficiency.");
    }
    return /*#__PURE__*/React.createElement("span", {
      "data-testid": "conditional-admission-require-elp"
    }, "For conditional admission, you are required to provide English proficiency scores:", /*#__PURE__*/React.createElement("ul", null, (marks === null || marks === void 0 ? void 0 : marks.minToeflTotal) && marks.minToeflTotal > 0 && /*#__PURE__*/React.createElement("li", {
      "data-testid": "pep-toefl-requirement"
    }, "Min TOEFL iBT: ".concat(marks.minToeflTotal, " ").concat(formatScores('toefl', TOEFL_NOT_REQUIRED_BAND_SCORE))), (marks === null || marks === void 0 ? void 0 : marks.minIeltsAverage) && marks.minIeltsAverage > 0 && /*#__PURE__*/React.createElement("li", {
      "data-testid": "pep-ielts-requirement"
    }, "Min IELTS overall: ".concat(marks.minIeltsAverage, " ").concat(formatScores('ielts', IELTS_NOT_REQUIRED_BAND_SCORE)), ((marks === null || marks === void 0 ? void 0 : marks.minIeltsAnyBandCount) || marks.minIeltsAnyBand) && /*#__PURE__*/React.createElement("i", null, /*#__PURE__*/React.createElement("br", null), "Any ".concat(marks.minIeltsAnyBandCount, " band").concat(!marks.minIeltsAnyBandCount || marks.minIeltsAnyBandCount <= 1 ? '' : 's', " may have a minimum of ").concat(marks.minIeltsAnyBand, " instead"))), (marks === null || marks === void 0 ? void 0 : marks.minDuolingoScore) && marks.minDuolingoScore > 0 && /*#__PURE__*/React.createElement("li", {
      "data-testid": "pep-duolingo-requirement"
    }, "Min Duolingo English Test Score: ".concat(marks.minDuolingoScore)), (marks === null || marks === void 0 ? void 0 : marks.minPteOverall) && marks.minPteOverall > 0 && /*#__PURE__*/React.createElement("li", {
      "data-testid": "pep-pte-requirement"
    }, "Min PTE overall: ".concat(marks.minPteOverall, " > ").concat(formatScores('pte', PTE_NOT_REQUIRED_BAND_SCORE)))), marks && !!(englishRequirementExceptions !== null && englishRequirementExceptions !== void 0 && englishRequirementExceptions.length) && /*#__PURE__*/React.createElement("div", {
      "data-testid": "pep-ere-info"
    }, "Conditional admission for this program has nationality specific English requirements.", /*#__PURE__*/React.createElement(EnglishRequirementExceptions, {
      englishRequirementExceptions: englishRequirementExceptions
    })));
  }, [englishScoreRequired, schoolName, marks, isElpRequired]);
  return content && /*#__PURE__*/React.createElement(CollapsibleCard, {
    fullWidth: true,
    initialOpenState: true,
    header: /*#__PURE__*/React.createElement(Typography, null, "This program offers conditional admissions"),
    nameForEventTracking: "English Score Requirements"
  }, content);
};
export var GreRequirements = function GreRequirements(_ref5) {
  var greRequirements = _ref5.greRequirements,
    pronoun = _ref5.pronoun;
  if (!(greRequirements !== null && greRequirements !== void 0 && greRequirements.required) || (greRequirements === null || greRequirements === void 0 ? void 0 : greRequirements.required) === 'none') {
    return null;
  }
  var attrString = function attrString(gr, attr, prefix) {
    var showUnlessLte = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var prefixedAtrr = prefix + attr;
    var attrPercentile = "".concat(prefixedAtrr, "Percentile");
    var attrValue = convertToFloat(gr[prefixedAtrr]);
    var attrPercentileValue = convertToFloat(gr[attrPercentile]);
    var scoreString = '';
    if (attrValue && attrValue > showUnlessLte || attrPercentileValue && attrPercentileValue > showUnlessLte) {
      var label = prefixedAtrr.replace('gmat', '').replace('min', '');
      label = label === 'VerbalQuantitativeCombined' ? 'Verbal & Quantitative combined' : label.charAt(0).toUpperCase() + label.substring(1);
      scoreString += "Min ".concat(label, ":");
      if (attrValue > showUnlessLte) {
        scoreString += " ".concat(attrValue);
      }
      if (attrPercentileValue > showUnlessLte) {
        scoreString += " [".concat(attrPercentileValue, " %]");
      }
    }
    return scoreString;
  };
  var attrsString = function attrsString(gr, attrs, prefix, showUnlessLte) {
    return attrs.map(function (attr) {
      return attrString(gr, attr, prefix, showUnlessLte);
    }).filter(Boolean).map(function (br) {
      return /*#__PURE__*/React.createElement("li", {
        key: "br"
      }, br);
    });
  };
  var greGmatRequirementTitle = function greGmatRequirementTitle(gr, pronoun) {
    var str = 'Other test requirements: ';
    switch (gr.required) {
      case 'gre':
        str += 'GRE Test';
        break;
      case 'gmat':
        str += 'GMAT Test';
        break;
      case 'either':
        str += 'Either of GRE or GMAT Tests';
        break;
      case 'both':
        str += 'Both of GRE and GMAT Tests';
        break;
      default:
        break;
    }
    str += ' required';
    var maxGpaRequired = convertToFloat(gr.maxGpaToBeRequired);
    if (maxGpaRequired !== null && maxGpaRequired < 100) {
      str += " (unless ".concat(pronoun, " GPA is above ").concat(gr.maxGpaToBeRequired, " out of 100)");
    }
    return str;
  };
  var greRequirementOneLine = function greRequirementOneLine(gr) {
    var breakdown = attrsString(gr, ['VerbalQuantitativeCombined', 'Verbal', 'Quantitative', 'Writing'], 'min');
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Min GRE requirement:", breakdown && /*#__PURE__*/React.createElement("ul", null, breakdown));
  };
  var gmatRequirementOneLine = function gmatRequirementOneLine(gr, showUnlessLte) {
    var breakdown = attrsString(gr, ['Total', 'Verbal', 'Quantitative', 'Writing'], 'gmatMin', showUnlessLte);
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Min GMAT requirement:", breakdown && /*#__PURE__*/React.createElement("ul", null, breakdown));
  };
  return /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    id: "gre-requirements"
  }, /*#__PURE__*/React.createElement(CollapsibleCard, {
    fullWidth: true,
    initialOpenState: true,
    header: /*#__PURE__*/React.createElement(Typography, null, greGmatRequirementTitle(greRequirements, pronoun)),
    nameForEventTracking: "GRE Requirements"
  }, /*#__PURE__*/React.createElement("ul", null, ['gre', 'either', 'both'].includes(greRequirements.required) && /*#__PURE__*/React.createElement("li", null, greRequirementOneLine(greRequirements)), greRequirements.required === 'either' && 'OR', greRequirements.required === 'both' && 'AND', ['gmat', 'either', 'both'].includes(greRequirements.required) && /*#__PURE__*/React.createElement("li", null, gmatRequirementOneLine(greRequirements, GMAT_NOT_REQUIRED_BAND_SCORE)))));
};